import React from 'react'
import { BsTelephone } from 'react-icons/bs';
import { Link } from 'react-router-dom';

export default function GetTouch() {
    return (
        <div className="container md:mt-24 mt-16">
            <div className="grid grid-cols-1 text-center">
                <h3 className="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">Have Question ? Get in touch!</h3>
                <div className="mt-6">
                    <Link to="/contact" className="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full me-2 mt-2 inline-flex items-center">  Contact us</Link>
                </div>
            </div>
        </div>
    )
}
